<template>
    <div class="mb-4">
        <input-label
            v-if="label"
            :label="label"
            :required="required"
        />
        <div
            :class="inputClass"
            class="mt-1.5"
        >
            <div
                :class="['block', i > 0 ? 'mt-2' : '']"
                v-for="(option, i) in options"
                v-bind:key="i"
            >
                <label>
                    <input
                        class="mr-2 translate-y-0.5"
                        type="radio"
                        :value="option.value"
                        :name="name"
                        :required="required"
                        v-model="value"
                        @change="$emit('update:content', this.value)"
                    />
                    {{option.label}}
                </label>
                <div
                    v-if="option.byline"
                    class="text-xs text-gray-500 pl-6"
                >
                    {{option.byline}}
                </div>
            </div>

            <label
                v-if="allowCustomAnswer"
                class="flex items-center mt-2"
            >
                <input
                    class="mr-2"
                    type="radio"
                    :name="name"
                    :value="customAnswer"
                    :required="false"
                    v-model="value"
                />
                <input-text
                    class="!mb-0"
                    v-model:content="customAnswer"
                />
            </label>
        </div>
        <input-error v-if="error" :error="error" />
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            inputClass: '',
            value: null,
            customAnswer: '',
            enableCustomAnswer: false,
        }
    },
    props: {
        content: String,
        options: Array,
        error: String,
        label: String,
        required: Boolean,
        name: String,
        allowCustomAnswer: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        content: {
            handler() {
                if (JSON.stringify(this.content) === JSON.stringify(this.value)) { return; }

                this.value = this.content ? JSON.parse(JSON.stringify(this.content)) : null;
            },
            immediate: true
        },
        customAnswer: {
            handler() {
                if (this.enableCustomAnswer) {
                    this.value = this.customAnswer;
                }
            }
        },
        error: function(error){
            let classes = [];
            if( error !== '' ){
                classes.push('border-red-700')
            } else {
                classes.push('border-gray')
            }
            this.inputClass = classes.join(' ')
        }
    }
}
</script>
